import { DEFAULT_ROUNDED_TO_NUMBER, getRoundedNumberText } from '../utils/getRoundedNumberText';
import { useMemo } from 'react';

type Props = {
    roundedTo?: number;
    totalFound: number;
};

export const useGetFormattedSearchResultsText = ({ roundedTo = DEFAULT_ROUNDED_TO_NUMBER, totalFound }: Props) => {
    return useMemo(() => getRoundedNumberText({ roundedTo, totalFound }), [totalFound, roundedTo]);
};
